const session_id = generateUUID();

export function tracker(event_name, params) {
    var tracker_url = `${$('body').data('tracking-base-url')}/api/v3/event/tracker`;

    let tracker_data = {}
    let context_data = {}

    $.each(params, function (key, value) {
        context_data[key] = value
    });

    let query_params = new URLSearchParams(window.location.search);
    query_params.forEach((value, key) => {
        context_data[key] = value
    });

    $.each(["__rg_cookie_id__", "__tracker_session_id__"], function (_, param) {
        if (trackerGetCookie(param) !== "") {
            tracker_data[param] = trackerGetCookie(param)
        }
    });

    let user_agent = navigator.userAgent
    let client_ua = user_agent.split(' (')[0];
    let info = user_agent.split(' (')[1].split(')')[0];
    let client_device;
    if (info.indexOf('Mobile') !== -1 || info.indexOf('Tablet') !== -1) {
        client_device = 'Mobile/Tablet';
    } else {
        client_device = 'Desktop';
    }
    let client_os = info.split(';')[0];
    let client_os_version = info.split('; ')[1] || 'Unknown';
    let connection_type = "-"
    if (navigator.connection && navigator.connection.effectiveType) {
        connection_type = navigator.connection.effectiveType
    }

    let user_serial = $('input[name="identifier_serial"]').val() || context_data["identifier_serial"]

    let payload = {
        "sessionId": session_id,
        "cookiesId": tracker_data["__rg_cookie_id__"],
        "deviceId": "",
        "memberId": user_serial,
        "isLogged": Boolean(user_serial),
        "eventType": event_name,
        "eventVersion": 1,
        "clientDevice": client_device,
        "clientUA": client_ua,
        "appVersion": "-",
        "clientOS": client_os,
        "clientOSVersion": client_os_version,
        "clientTimestamp": new Date().toISOString(),
        "context": JSON.stringify(context_data),
        "connectionType": connection_type,
        "source": "rg-form",
        "clientIP": "-",
        "currentPage": window.location.href,
        "previousPage": document.referrer, 
        "utmSource": context_data["utmSource"] || context_data["utm_source"],
        "utmMedium": context_data["utmMedium"] || context_data["utm_medium"],
        "utmCampaign": context_data["utmCampaign"] || context_data["utm_campaign"],
        "utmTerm": context_data["utmTerm"] || context_data["utm_term"],
        "utmContent": context_data["utmContent"] || context_data["utm_content"],
        "originUrl": window.location.href,
        "marketingId": context_data["marketingId"] || context_data["marketing_id"],
      }

    $.ajax({
        url: tracker_url,
        type: 'POST',
        data: payload,
        success: function (data) { },
        error: function (data) { }
    });
}

export function trackerGetCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function generateUUID() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function(c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
    });
}
